import React from 'react';
import { FaWhatsapp } from "react-icons/fa";

export default function Whatsapp() {
  return (
    <div className="fixed bottom-5 right-5 flex items-center gap-3 z-20">
      {/* Message bubble with tail */}
      <div className="whatsapp-float relative bg-green-500 text-white text-sm max-sm:text-xs font-medium px-5 py-3 max-sm:px-3 rounded-full shadow-lg whitespace-nowrap">
        Hi, Do you have any questions?
        {/* Tail pointing right toward the icon */}
        <div className="absolute top-1/2 -right-1 -translate-y-1/2 w-3 h-3 bg-green-500 rotate-45"></div>
      </div>

      {/* WhatsApp Icon */}
      <a
        href="https://api.whatsapp.com/send?phone=923700086022"
        target="_blank"
        rel="noopener noreferrer"
        className="relative flex items-center justify-center text-3xl bg-green-500 text-white w-16 h-16 rounded-full shadow-lg border-4 border-white cursor-pointer transition-all duration-300 hover:scale-125 hover:shadow-2xl z-10"
      >
        <FaWhatsapp />
      </a>

      <style>{`
        @keyframes whatsappFloat {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-8px);
          }
        }

        .whatsapp-float {
          animation: whatsappFloat 3s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
}